import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { loadActiveUser, getActiveUserNoDispatch } from "../redux/users/usersActions";
import { withRouter } from "react-router-dom";

export default function withAuth(AuthComponent) {
    var auth = class AuthWrapped extends Component {
        constructor(props) {
            super(props);
            this.state = {
                authenticated: null,
            };

            this.checkAuthentication = this.checkAuthentication.bind(this);
            this.checkAuthentication();
        }

        async checkAuthentication() {
            await getActiveUserNoDispatch().then((user) => {
                if (!user) {
                    this.props.history.push("/Login");
                }
            });
        }

        render() {
            if (this.props.activeUser !== null) {
                return <AuthComponent user={this.props.activeUser} {...this.props} />;
            } else {
                return null;
            }
        }
    };

    const mapStateToProps = (state) => {
        return {
            activeUser: state.activeUser,
        };
    };
    const mapDispatchToProps = (dispatch) => {
        return {
            loadActiveUser: (onSuccess) => dispatch(loadActiveUser(onSuccess)),
        };
    };
    return compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(auth);
}
